import { makeStyles } from "@material-ui/core/styles";
export const CommonCss = makeStyles((theme) => ({
  navContainer: {
    maxWidth: "1600px",
    position: "relative",
    margin: "auto",
  },
  justifyContentBetween: {
    justifyContent: "space-between!important",
  },
  alignItemsStretch: {
    alignItems: "stretch",
  },
  textDecoration: {
    textDecoration: "none",
  },
  cursorPointer: {
    cursor: "pointer",
  },
  textTransformCapitalize: {
    textTransform: "capitalize",
  },
  active:{
    color:"green"
  },
  pending:{
    color:"orange"        
  },
  inactive:{
    color:"red"
  }
}));
